import TopBarMoneyIcon from 'assets/icons/money-unit-top-bar.png'
import MoneyIcon from 'assets/icons/money-unit-border.png'
import CleanMoneyIcon from 'assets/icons/money-unit.svg'
import EmployeeIcon from 'assets/characters/storage-worker-girl.png'
import BuildingIcon from 'assets/icons/building.png'
import ClockIcon from 'assets/icons/clock.png'
import RdGirlIcon from 'assets/characters/rd-girl.png'

export default {
  'account-receivables': MoneyIcon,
  arrow: CleanMoneyIcon,
  bordered: MoneyIcon,
  building: BuildingIcon,
  default: MoneyIcon,
  employee: EmployeeIcon,
  lg: MoneyIcon,
  xl: MoneyIcon,
  vertical: MoneyIcon,
  'top-bar': TopBarMoneyIcon,
  'quarter-lg': ClockIcon,
  'quarter-xl': ClockIcon,
  rd: RdGirlIcon,
  procurement: MoneyIcon
}
